export default {
  title: "Go2transfer"
};
